import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";
import sp1 from '../Images/sp1.png'
import sp2 from '../Images/sp2.jpg'
import sp3 from '../Images/sp3.jpg'

import { useNavigate } from 'react-router-dom';

// --- Styled Components ---

const GallerySection = styled.section`
  padding: 10px 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const GalleryTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;

  text-transform: uppercase;
  color: #439E6D;
`;

const P = styled.p`
  margin-bottom: 10px;
  text-align:center;
  font-size:1.1rem;
`

const Grid = styled.div`
  display: grid;
  gap: 20px;
  margin-bottom:10px;

  /* Desktop: 3 columns */
  grid-template-columns: repeat(3, 1fr);

  /* Tablet/Mobile: 2 columns */
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Small Mobile: 1 column (Optional, but recommended for tiny screens) */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ImageCard = styled.div`
  position: relative;
  height: 250px;
  overflow: hidden;
  border-radius: 4px;
  border: 4px solid #439E6D; // Matches your navy blue theme
  background-color: #eee;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${ImageCard}:hover & {
    transform: scale(1.1);
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(13, 42, 113, 0.85); // Transparent navy
  color: white;
  padding: 15px;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;

  ${ImageCard}:hover & {
    transform: translateY(0);
  }
`;

const ProjectName = styled.h6`
  margin: 0;
//   font-size: 0.rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;




const HireButton = styled.button`
  background-color: #439E6D;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  

  display: block;
  margin: 0 auto;

  &:hover {
    background-color: #475569;
  }
`;

// --- Mock Data ---

const projects = [
  { id: 1, title: "Statutory/Consultancy surveys for the issuance and renewal of pipeline routes ROW and concession/lease licenses.", img: sp3 },
  { id: 2, title: "Land administration and management services.", img: sp2 },
  { id: 3, title: "eographical information data management..", img: sp1 },
 
];

// --- Component ---

const SpecialSurveyPage = () => {
    const navigate = useNavigate();
  return (
    <GallerySection>
      <Fade triggerOnce>
        <GalleryTitle>SPECIAL SURVEY</GalleryTitle>
        <P>We offer precise positioning for clients and specialized survey and our range of special survey  services include:</P>
     </Fade>


      <Grid>
        <Fade cascade damping={0.15} triggerOnce>
          {projects.map((project) => (
            <ImageCard key={project.id}>
              <StyledImage src={project.img} alt={project.title} />
              <Overlay>
                <ProjectName>{project.title}</ProjectName>
              </Overlay>
            </ImageCard>
          ))}
        </Fade>
      </Grid>

       <HireButton onClick={()=>navigate('/contactus')} >Hire Us</HireButton>
    </GallerySection>
  );
};

export default SpecialSurveyPage;